import { render, staticRenderFns } from "./SilicagelRubberPendant.vue?vue&type=template&id=fa3190a4&scoped=true&"
import script from "./SilicagelRubberPendant.vue?vue&type=script&lang=js&"
export * from "./SilicagelRubberPendant.vue?vue&type=script&lang=js&"
import style0 from "./SilicagelRubberPendant.vue?vue&type=style&index=0&id=fa3190a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3190a4",
  null
  
)

component.options.__file = "SilicagelRubberPendant.vue"
export default component.exports